import React from 'react';
import PropTypes from 'prop-types';

import {
  EMPTY_MESSAGE_ACTIVE_THREADS,
  EMPTY_MESSAGE_ACTIVE_THREADS_EN,
  EMPTY_MESSAGE_LEADERBOARDS,
  EMPTY_MESSAGE_LEADERBOARDS_EN,
} from '../../utils/common/constant';
import { SettingConsumer } from '../../contexts/settingContext';

import SectionThreadListEmpty from '../styled/section/SectionThreadListEmpty';
import ParagraphThreadListEmpty from '../styled/paragraph/ParagraphThreadListEmpty';

const EmptyMessageForum = ({ archived }) => {
  return (
    <SettingConsumer>
      {
        ({ locale }) => {
          const emptyMessageActiveThreads = locale === 'id' ? EMPTY_MESSAGE_ACTIVE_THREADS : EMPTY_MESSAGE_ACTIVE_THREADS_EN;
          const emptyMessageArchivedThreads = locale === 'id' ? EMPTY_MESSAGE_LEADERBOARDS : EMPTY_MESSAGE_LEADERBOARDS_EN;
          return (
            <SectionThreadListEmpty>
              <ParagraphThreadListEmpty>
                {!archived ? emptyMessageActiveThreads : emptyMessageArchivedThreads}
              </ParagraphThreadListEmpty>
            </SectionThreadListEmpty>
          );
        }
      }
    </SettingConsumer>
  );
};

EmptyMessageForum.propTypes = {
  archived: PropTypes.bool.isRequired,
};

export default EmptyMessageForum;
